import React, { useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import COLORS from "../styled.constants";
import { sendForm } from "emailjs-com";
import { init } from "@emailjs/browser";
init("aR5AwwOgyN73-cWUg");

function Contact() {
  const form = useRef();
  const PageTransition = styled(motion.div)``;

  const sendEmail = (e) => {
    e.preventDefault();
    sendForm(
      "service_7mgvn1g",
      "template_cl8xldj",
      form.current,
      "aR5AwwOgyN73-cWUg"
    ).then(
      () => {
        alert("Message successfully sent!");
        window.location.reload(false);
      },
      () => {
        alert("Failed to send the message, please try again");
      }
    );
  };

  const Title = styled.div`
    display: flex;
    color: ${COLORS.title};
    flex-direction: column;
    align-items: center;
    padding-top: 8rem;
    h2 {
      padding-top: 50px;
      text-transform: uppercase;
      font-size: 1.8em;
      padding-bottom: 1rem;
    }
  `;

  const PlText = styled.div`
    font-size: 1.5em;
    color: ${COLORS.text};
    margin-bottom: 1rem;
  `;

  const ContactForm = styled.div`
    padding: 0.5rem;
    ul {
      li {
        padding: 0;
        margin: 0;
        list-style: none;
        margin-bottom: 10px;
        /* opacity: 0; */
        overflow: hidden;
        display: block;
        clear: both;
        position: relative;
        animation: fadeInUp 2s 2s;
        animation-fill-mode: forwards;
      }
      li.half {
        width: 49%;
        margin-left: 2%;
        float: left;
        clear: none;

        &:first-child {
          margin-left: 0;
        }
      }
    }
    textarea:focus,
    input:focus {
      outline: none;
    }
    textarea {
      resize: none;
    }
    input[type="text"],
    input[type="email"] {
      width: 100%;
      border: 0;
      height: 50px;
      font-size: 20px;
      padding: 0 20px;
      box-sizing: border-box;
      color: ${COLORS.text};
    }

    textarea {
      width: 100%;
      border: 0;
      height: 50px;
      font-size: 20px;
      color: ${COLORS.text};
      padding: 20px;
      box-sizing: border-box;
      min-height: 150px;
    }
    .flat-button {
      color: ${COLORS.button};
      cursor: pointer;
      font-size: 20px;
      letter-spacing: 3px;
      text-decoration: none;
      padding: 8px 10px;
      border: 1px solid;
      float: left;
      border-radius: 4px;
      background: 0 0;
      text-transform: uppercase;
      float: right;
      text-align: center;
      margin-right: 10px;
      background-color: transparent;
      outline: none;
      cursor: poiner;
      color: ${COLORS.button};
    }
    .flat-button:hover {
      background-color: ${COLORS.button};
      color: ${COLORS.text};
    }
  `;

  return (
    <PageTransition
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Title>
        <PlText>Hey, let's get in touch!</PlText>
        <h2>Get in touch</h2>
        <ContactForm>
          <form ref={form} onSubmit={sendEmail}>
            <ul>
              <li className="half">
                <input placeholder="Name" type="text" name="name" required />
              </li>
              <li className="half">
                <input placeholder="Email" type="email" name="email" required />
              </li>
              <li>
                <input
                  placeholder="Subject"
                  type="text"
                  name="subject"
                  required
                />
              </li>
              <li>
                <textarea
                  placeholder="Message"
                  name="message"
                  required
                ></textarea>
              </li>
              <li>
                <input type="submit" className="flat-button" value="SEND" />
              </li>
            </ul>
          </form>
        </ContactForm>
      </Title>
    </PageTransition>
  );
}

export default Contact;
